/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import moment from 'moment';

/**
 * Calculates the minutes that have passed from midnight from the given time
 * @param timeString The time to compare
 * @returns {number} The diff from timeString to midnight in minutes
 */

const timeToMinutesAfterMidnight = (timeString) => {
  if (!timeString) {
    return 0;
  }
  // Time string to moment format
  const mmt = moment(timeString);
  // Moment at midnight
  const mmtMidnight = mmt.clone().startOf('day');
  // Difference in minutes
  return mmt.diff(mmtMidnight, 'minutes');
};

export default timeToMinutesAfterMidnight;
